export interface OfflineRegistration {
  scriptUrl: './sw.js';
  scope: './';
}

export function offlineRegistration(_pathname: string): OfflineRegistration {
  return { scriptUrl: './sw.js', scope: './' };
}
